import configs from "configs";

export default {
  API_URL: configs.REACT_APP_SERVER_URL,
  FIlE_UPLOAD: `${configs.FILE_IMAGE_URL}`,
  FILE_DOWNLOAD_URL: configs.REACT_APP_FILE_DOWNLOAD_URL,
  // CMS Api url
  PRIVACY_POLICY: "PRIVACY_POLICY",

  // Posts api url
  POSTS: "posts",

  // Auth api url
  LOGIN: "admin/login",

  SEND_OTP: "admin/send-otp",

  VERIFY_OTP: "admin/verify-otp",
  LOGOUT: "admin/logout",

  REFRESH_TOKEN: "admin/refresh-access-token",

  FORGOT_PW: "admin/forgot-password",

  RESET_PW: "admin/reset-password",

  GET_COLUMN_TABLE_SETTINGS: "admin/table-column-settings",

  // User profile url
  PROFILE: "admin/profile",
  EDIT_PROFILE: "admin/edit-profile",
  FILE_UPLOAD: "admin/image-file-upload",
  MULTI_FILE_UPLOAD: "/admin/multiple/image-file-upload",

  CHANGE_PASSWORD: "admin/change-password",
  GLOBAL_CONFIG: "admin/global-config",
  DELETE_PROFILE: "admin",

  //  settings
  META_DATA: "settings/general/meta-data",
  SITE_SETTING: "settings/general/site-settings",
  DATE_TIME: "settings/general/date-time",
  ANALYTICAL_DATA: "settings/general/analytical-data",
  SITE_UN_MAINTENANCE: "settings/general/site-un-maintenance",
  SOCIAL_MEDIA_SDK: "settings/social-media/social-media-sdk",
  SOCIAL_MEDIA_LINK: "settings/social-media/social-media-link",
  CHANGE_STATUS: "settings/social-media/sdk",
  SMTP_DETAILS: "settings/smtp",
  SMS_DETAILS: "settings/sms",
  NOTIFICATION: "settings/email-settings/notifications",
  LANGUAGE_LABEL: "settings/language-preferences/label",
  ADD_EDIT_PAYMENT: "settings/payment-gateway",
  TWO_WAY_AUTHENTICATION: "settings/general/change-2fa-status",
  GET_TWO_WAY_AUTHENTICATION: "settings/general/get-2fa",
  //role
  GET_ALL_PERMISSSION: "role/get-all-permission",
  ROLE: "role",
  CHANGE_ROLE: "/role/change-role",
  ROLE_LISTING: "role/listing",
  USER_LIST: "role/user-list",

  //emailTemplates
  LISTING: "email-template/listing",
  STATUS_CHANGE: "email-template/change-status",
  EMAIL_TEMPLATES: "email-template",

  //blog
  BLOG_CATEGORY_LISTING: "blog-categories/listing",
  BLOG_CATEGORY: "blog-categories",
  BLOG_CATEGORY_LIST: "blog-categories/dropdown",
  BLOG_LIST: "blog/listing",
  BLOG: "blog",
  BLOG_LIST_DOWNLOAD: "blog/download",
  BLOG_PUBLISH: "blog/publish",
  BLOG_CATEGORY_DOWNLOAD: "blog-categories/download",

  //faq
  FAQ_CATEGORY_LISTING: "faq-categories/listing",
  FAQ_CATEGORY: "faq-categories",
  FAQ_CATEGORY_LIST: "faq-categories/dropdown",
  FAQ_LISTING: "faq/listing",
  FAQ: "faq",

  //users
  APP_USER: "/admin/user-management",
  APP_USER_PASSWORD_CHANGE: "/admin/user-management/app-user-password-change",
  PATIENTS: "/admin/patient-management",
  LISTING_ADMIN_MANAGEMENT: "admin-management",
  ADMIN_MANAGEMENT: "admin-management",
  //master
  TERRITORY_DROPDOWN: "/admin/dropdown/territories",
  PATIENTS_DROPDOWN: "/admin/dropdown/patients",
  APP_USER_DROPDOWN: "/admin/dropdown/users",
  MASTER_ADD_TERRITORY: "/admin/master/territories",
  MASTER_ETIOLOGY: "/admin/master/etiologies",
  MASTER_ADD_DESIGNATION: "/admin/master/designations",
  MASTER_ADD_PAGE_TITLE: "/admin/master/question_pages",
  NOT_ASSESS_REASON: "/admin/master/not-assess-reasons",
  LISTING_USER_MANAGEMENT: "user-management/listing",
  ADMIN_USERS_DOWNLOAD: "admin-management/download",
  USER_MANAGEMENT_DOWNLOAD: "user-management/download",
  USER_MANAGEMENT: "user-management",
  USER_WOUND_MANAGEMENT: "user-management/wounds",
  USER_DETAILS_DOWNLOAD: "user-management/download",
  USER_REVOKE_SUSPENSION: "user-management/users/revoke-suspension",
  USER_REPORT_LISTING: "user-management/reported-users",
  USER_REPORT_DOWNLOAD: "user-management/reported-users/download",
  USER_REPORT_CANCEL_SUSPENSION: "user-management/users/cancel-suspension",
  USER_REPORT_SUSPEND: "user-management/reported-users/suspend",
  USER_REPORT_REVOKE_SUSPENSION: "user-management/users/revoke-suspension",

  //Static page management
  STATIC_PAGE_MANAGEMENT_LISTING: "static-page/listing",
  STATIC_PAGE_MANAGEMENT: "static-page",
  STATIC_PAGE_MANAGEMENT_DOWNLOAD: "staticPage/download",

  //Commom Filter API
  SAVE_FILTER: "common/filter",
  SAVE_COLUMN: "common/column",

  //dashboard
  DASHBOARD_STATICS: "admin/dashboard/statics",
  DASHBOARD_BAR_GRAPH: "admin/dashboard/bar-graph",
  DASHBOARD_DOWNLOAD_REPORT: "admin/dashboard/download-report",
  DASHBOARD_LINE_GRAPH: "admin/dashboard/line-graph",

  // Questionnaire
  QUESTION_MANAGEMANT: "/admin/question",
  //Visit
  VISIT_LISTING: "/admin/wound/visit-list",
  WOUND_LISTING: "/admin/wound/details",
  EDIT_WOUND: "/admin/wound",
  EDIT_ASSESSMENT: "/admin/assessment",
};
